module.exports = __webpack_public_path__ + "static/media/img2-2.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/K/img2-2.png
// module id = 2150
// module chunks = 3